import Dialog from "components/ui/Dialog/Dialog";
import Trans from "features/translation/components/Trans";
import Button from "components/ui/Button/Button";
import { useDialog } from "context/DialogContext";

const GroupMemberAdminLeaveDialog = () => {
  const { hideDialog } = useDialog();

  const onConfirm = async () => {
    hideDialog();
  }

  return (
    <Dialog title={ `U kunt deze groep niet verlaten` }>
      <div className={ `dialog__row` }>
        <Trans
          text={ `U kunt deze groep niet verlaten omdat u beheerder bent van de groep.` }/>
      </div>
      <div className={ `dialog__row` }>
        <Trans
          text={ `U kunt de groep eventueel wel aan iemand overdragen, stuur hiervoor een e-mail naar @email en vermeld daarin uw naam en de naam van deze groep.` }
          variables={ { '@email': 'trefpunt@anbo-pcob.nl' } }
        />
      </div>
      <div className="dialog__buttons dialog__buttons--end">
        <Button variant={ `secondary` } onClick={ onConfirm }>Sluiten</Button>
      </div>
    </Dialog>
  );
}

export default GroupMemberAdminLeaveDialog;
